import {
	component as baseComponent,
	conditionalField as baseConditionalField,
	section as baseSection,
} from "@repo/dynamicEditor/src/models/component";
import { componentType as componentTypeBase, sectionType } from "@repo/dynamicEditor/src/models/enums";
import {
	MappedComponent as baseMappedComponent,
	MappedDyno as baseMappedDyno,
	MappedSection as baseMappedSection,
} from "@repo/dynamicEditor/src/models/mappedComponent";

export interface section extends baseSection<sectionType, conditionalField> {}

export interface component extends baseComponent<conditionalField> {}

export interface MappedDyno extends baseMappedDyno<conditionalField> {}
export interface MappedSection extends baseMappedSection {}

export interface MappedComponent extends baseMappedComponent<conditionalField, component> {}

export interface conditionalField extends baseConditionalField {
	stateId?: number[];
	channelId?: number[];
}

export enum componentTypePortal {
	// 4XX => LocationPortal components
	score = 240,
	individualScore = 241,
}

export const componentType = { ...componentTypeBase, ...componentTypePortal };
export type componentType = componentTypePortal | componentTypeBase;
